import { TextField } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';

const values = [
	{
		value: 'Auction',
		label: 'Auction',
	},
	{
		value: 'Silent',
		label: 'Silent',
	},
];

export default function ProcessTypeSelect({ label, variant, style }) {
	const [value, setValue] = React.useState('Auction');

	const handleChange = event => {
		setValue(event.target.value);
	};
	return (
		<TextField
			select
			value={value}
			onChange={handleChange}
			style={style}
			variant={variant}
			label={label}
		>
			{values.map(option => (
				<MenuItem key={option.value} value={option.value}>
					{option.label}
				</MenuItem>
			))}
		</TextField>
	);
}
